import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import './assets/responsive'

import './utils/vue.filter';

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import './assets/styles/default.styl';
// 移动端样式
import './assets/styles/mobile.styl';

import Toast from 'mand-mobile/lib/toast';


import axios from 'axios';
// import Api from '../sxui/api/base';
import Api from './utils/ajax';
Vue.prototype.$toast = Toast;
Vue.use(Antd);
Vue.prototype.$ajax = Api;
Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

import dynamicNodePlugin from './utils/dynamic-component-plugin'

Vue.use(dynamicNodePlugin)

const app = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App) // 必须使用render渲染
});

export default app;
